/**
 * ประเมินของฉัน (/me/evaluations) — พนักงานเห็นแบบประเมินที่ต้องกรอก
 * (ตนเอง / ลูกน้อง(หัวหน้า) / เพื่อนร่วมงาน) + สถานะกรอกแล้ว/ยัง
 */
import { PageLayout } from '../components/layout/PageLayout';
import { useMyEvaluations } from '../hooks';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, CheckCircle2, ChevronRight } from 'lucide-react';

const ROLE_TH: Record<string, string> = {
  self: 'ประเมินตนเอง',
  supervisor: 'ประเมินลูกน้อง (หัวหน้า)',
  peer: 'ประเมินเพื่อนร่วมงาน',
};

export function MyEvaluations() {
  const { data, isLoading } = useMyEvaluations();
  const nav = useNavigate();
  const rows = data?.evaluations ?? [];
  const pending = rows.filter((r) => r.status === 'pending');
  const done = rows.filter((r) => r.status === 'submitted');

  return (
    <PageLayout title="แบบประเมิน">
      {isLoading ? (
        <p className="py-8 text-center text-gray-400">กำลังโหลด…</p>
      ) : rows.length === 0 ? (
        <div className="py-12 text-center text-gray-400 flex flex-col items-center gap-2">
          <ClipboardList className="w-8 h-8 opacity-40" />
          ยังไม่มีแบบประเมินที่ต้องกรอก
        </div>
      ) : (
        <div className="space-y-5">
          {pending.length > 0 && (
            <section>
              <h2 className="text-sm font-semibold text-gray-700 mb-2">รอกรอก ({pending.length})</h2>
              <div className="space-y-2">
                {pending.map((r) => (
                  <button
                    key={r.id}
                    onClick={() => nav(`/me/evaluations/${r.id}`)}
                    className="w-full flex items-center gap-3 p-3 bg-white rounded-xl border border-amber-200 hover:border-amber-300 text-left"
                  >
                    <div className="flex-1">
                      <div className="font-medium text-gray-800">{ROLE_TH[r.role] ?? r.role}</div>
                      <div className="text-xs text-gray-500">
                        {r.role === 'self' ? r.title : `${r.subject_name} · ${r.title}`} · ครบกำหนด {r.due_date}
                      </div>
                    </div>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </section>
          )}

          {done.length > 0 && (
            <section>
              <h2 className="text-sm font-semibold text-gray-700 mb-2">กรอกแล้ว ({done.length})</h2>
              <div className="space-y-2">
                {done.map((r) => (
                  <div key={r.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-100">
                    <CheckCircle2 className="w-4 h-4 text-green-600" />
                    <div className="flex-1">
                      <div className="font-medium text-gray-700">{ROLE_TH[r.role] ?? r.role}</div>
                      <div className="text-xs text-gray-400">
                        {r.role === 'self' ? r.title : `${r.subject_name} · ${r.title}`}
                      </div>
                    </div>
                    <span className="text-xs text-green-600">ส่งแล้ว</span>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>
      )}
    </PageLayout>
  );
}
